// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"4f447f82","89":"cf938080"}[chunkId] + ".chunk.css";
};